import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getNumFromStr, getStyle } from '../../utils';
import '../../../styles/scss/style.css';

//Returning the component
class FormTextfield extends Component {
	componentDidMount() {
		const textAreas = document.getElementsByClassName('form__inputWords');
		for (let i=0; i<=textAreas.length-1; i++) {
			textAreas[i].addEventListener('click', (e) => {
				let savedValue = textAreas[i].value;
        textAreas[i].value = '';
        textAreas[i].baseScrollHeight = textAreas[i].scrollHeight;
        textAreas[i].value = savedValue;
			});
		}
	}
	handleChange = (e) => {
		const minRows = 1;
		e.target.rows = minRows;
		e.target.rows += Math.ceil((e.target.scrollHeight - e.target.baseScrollHeight)  / this.numerator);
		this.props.onChange(e);
	}
	handleFocus = ({ target }) => {
		const paddingTop = getNumFromStr(getStyle(target, 'paddingTop'));
		const paddingBottom = getNumFromStr(getStyle(target, 'paddingBottom'));
		this.numerator = target.scrollHeight - paddingTop - paddingBottom;
	}
	render() {
		return (
			this.props.readOnly ?
			<textarea
				className={`form__inputWords form__inputWords--complete ${this.props.classType}`}
				id={this.props.id} placeholder={this.props.placeholder}
				name={this.props.name} form={this.props.form}
				value={this.props.value}
				onChange={this.props.onChange}
				rows='1'
				readOnly
			/>
			:
			<textarea
				className={`form__inputWords ${this.props.classType}`}
				id={this.props.id}
				placeholder={this.props.placeholder}
				name={this.props.name}
				form={this.props.form}
				onChange={this.handleChange}
				onFocus={this.handleFocus}
				onBlur={this.props.handleBlur}
				rows='1'
				maxLength='256'
			/>
		)
	}
}

//Making sure that it has a text property when it's declared
FormTextfield.propTypes = {
	classType: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string.isRequired,
	name: PropTypes.string,
	form: PropTypes.string,
}

export default FormTextfield;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/FormInputWords.jsx